/**
 * Lazy-load autoplay background videos.
 *
 * Big background <video> files are the heaviest thing on the page. Instead of
 * downloading every one at page load, we defer each video's download until it
 * is about to scroll into view, then start playback. Videos that are already
 * near the top load almost immediately; ones far down the page cost nothing
 * until the visitor scrolls toward them.
 *
 * Markup contract:
 *   <video muted loop playsinline preload="none" data-lazy-video>
 *     <source data-src="…/file.mp4" type="video/mp4">
 *   </video>
 * (No `src` and no `autoplay` up front — this script fills them in.)
 */
(function () {
  function activate(video) {
    if (video.dataset.lazyLoaded) return;
    video.dataset.lazyLoaded = '1';
    var source = video.querySelector('source[data-src]');
    if (source && !source.getAttribute('src')) {
      source.setAttribute('src', source.dataset.src);
      video.load();
    }
    var played = video.play();
    if (played && played.catch) played.catch(function () {});
  }

  function init() {
    var videos = document.querySelectorAll('video[data-lazy-video]:not([data-lazy-loaded])');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(activate);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          activate(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' });

    videos.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-scan when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
